<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.freeze"
      @keydown.esc="dialog.freeze = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Freeze Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in configHeaders" 
                        :key="index"
                        class="px-0"
                        @click="item.freeze = !item.freeze ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.freeze">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.freeze ? 'font-weight-bold' : ''"
                            :style="item.freeze ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Freeze
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.hide"
      @keydown.esc="dialog.hide = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hide Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.hide = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in headers" 
                        :key="index"
                        class="px-0"
                        @click="item.hide = !item.hide ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.hide">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.hide ? 'font-weight-bold' : ''"
                            :style="item.hide ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Hide
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="625"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <!-- {{ form.id === '' ? 'Tambah' : 'Ubah' }} --> Tambah Pesan

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <div class="body-2 mb-2">
                Pilih Penerima
              </div>
              <v-radio-group
                v-model="form.contact_type"
                row
                class="mt-0"
                v-on:change="form.contact_ids = ''; form.grup_id = '';"
                :color="set_color"
              >
                <v-radio
                  value="contact"
                  :color="set_color"
                >
                  <template v-slot:label>
                    <div>
                      Kontak
                    </div>
                  </template>
                </v-radio>
                <v-radio
                  value="grup"
                  :color="set_color"
                >
                  <template v-slot:label>
                    <div>
                      Grup
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>

              <div v-if="form.contact_type === 'contact'">
                <ValidationProvider 
                  name="Kontak" 
                  :rules="'required'" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Pilih Kontak
                    <!-- <span>
                      (boleh dikosongi)
                    </span> -->
                  </div>

                  <v-autocomplete
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details

                    :items="contact"
                    item-text="name"
                    item-value="id"
                    multiple
                    chips

                    v-model="form.contact_ids"
                    :success="form.contact_ids !== '' && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px; width: 100%;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Pilih Kontak {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.contact_ids !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        small
                        :color="set_color"
                        text-color="white"
                        class="my-1"
                        @click="data.select"
                        @click:close="remove(data.item)"
                      >
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </div>

              <div v-else>
                <ValidationProvider 
                  name="Grup" 
                  :rules="'required'" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Pilih Grup
                    <!-- <span>
                      (boleh dikosongi)
                    </span> -->
                  </div>

                  <v-autocomplete
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details

                    :items="grup"
                    item-text="name"
                    item-value="id"

                    v-model="form.grup_id"
                    :success="form.grup_id !== '' && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px; width: 100%;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Pilih Grup {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.grup_id !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                    <!-- <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        small
                        :color="set_color"
                        text-color="white"
                        class="my-1"
                        @click="data.select"
                        @click:close="remove(data.item)"
                      >
                        {{ data.item.name }}
                      </v-chip>
                    </template> -->
                  </v-autocomplete>
                </ValidationProvider>
              </div>

              <!-- <ValidationProvider 
                name="Type Pesan" 
                :rules="'required'" 
                v-slot="{ errors, valid }"> -->
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Type Pesan
                </div>

                <v-select
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details

                  v-uppercase
                  :items="[
                    {
                      text: 'Text',
                      value: 'string'
                    },
                    {
                      text: 'Gambar',
                      value: 'image'
                    },
                    {
                      text: 'File',
                      value: 'file'
                    }
                  ]"
                  item-text="text"
                  item-value="value"

                  v-on:change="form.caption = ''; file_text = ''; form.content_type === 'image' ? form.content = [] : form.content = ''"

                  v-model="form.content_type"
                  class="mb-6"
                  style="border-radius: 10px; width: 100%;">
                </v-select>

                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Type Text
                </div>

                <v-select
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details

                  v-uppercase
                  :items="[
                    {
                      text: 'Text Biasa',
                      value: 'Text Biasa'
                    },
                    {
                      text: 'Free Text',
                      value: 'Free Text'
                    }
                  ]"
                  item-text="text"
                  item-value="value"

                  v-model="type_pesan"
                  class="mb-6"
                  style="border-radius: 10px; width: 100%;">
                </v-select>

                <div v-if="form.content_type === 'string'">
                  <div v-if="type_pesan === 'Free Text'">
                    <div>
                      <span class="red--text">*</span>
                      Isi Pesan
                    </div>
                    <quill-editor 
                      ref="myTextEditor"
                      :options="{
                        placeholder: 'Isi Pesan',
                        modules: quill_modules
                      }"
                      v-model="form.content">
                    </quill-editor>
                  </div>

                  <div v-if="type_pesan === 'Text Biasa'">
                    <ValidationProvider 
                      name="caption" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Isi Pesan
                      </div>
                      
                      <v-textarea
                        style="max-width: 100%; border-radius: 10px;"
                        filled
                        rounded
                        dense
                        single-line
                        hide-details
    
                        class="mb-6"
                        :color="set_color"
                        placeholder="Isi Pesan"
    
                        v-model="form.content"
                        :success="form.content !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Caption {{ errors[0] }}
                            </v-tooltip>
                          </div>
    
                          <div v-if="form.content !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider>
                  </div>

                </div>

                <div v-if="form.content_type === 'image' || form.content_type === 'file'">
                  <div v-if="type_pesan === 'Free Text'">
                    <div class="mb-1">
                      Caption
                    </div>
                    <quill-editor 
                      ref="myTextEditor"
                      :options="{
                        placeholder: 'Isi Caption',
                        modules: quill_modules
                      }"
                      class="mb-2"
                      v-model="form.caption">
                    </quill-editor>
                  </div>
                  <div v-if="type_pesan === 'Text Biasa'">
                    <ValidationProvider 
                      name="caption" 
                      rules="" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <!-- <span class="red--text">*</span> -->
                        Caption
                      </div>
                      
                      <v-textarea
                        style="max-width: 100%; border-radius: 10px;"
                        filled
                        rounded
                        dense
                        single-line
                        hide-details
    
                        class="mb-6"
                        :color="set_color"
                        placeholder="Caption"
    
                        v-model="form.caption"
                        :success="form.caption !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Caption {{ errors[0] }}
                            </v-tooltip>
                          </div>
    
                          <div v-if="form.caption !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </ValidationProvider>
                  </div>
                </div>

                <div v-if="form.content_type === 'image'">
                  <div class="mb-1">
                    <span class="red--text">*</span>
                    Isi Pesan
                  </div>

                  <v-row>
                    <v-col cols="12" md="4" v-for="(item, index) in form.content" :key="index">
                      <v-card flat width="100%" height="180" style="border-radius: 15px;
                                  border: 2px solid #eaeaea; 
                                  border-style: dashed;">
                        <v-btn
                          @click="form.content.splice(index, 1)"
                          v-if="form.content.length > 0"
                          icon
                          style="position: absolute; top: -15px; right: -15px;">
                          <v-icon
                            color="red">
                            mdi-close-circle
                          </v-icon>
                        </v-btn>
                        <v-img
                          alt="pakualaman" 
                          width="100%"
                          height="178"
                          contain
                          gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                          :src="item"
                          style="border-radius: 15px;"
                          class="ma-auto d-flex align-center text-center">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                      <uploadfolder v-model="upload.folder"
                        style="width: 100%; height: 180px;">
                        <div 
                          slot="activator" 
                          class="cursor-pointer">
                          <v-card 
                            flat
                            width="100%"
                            height="180"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #eaeaea; 
                                  border-style: dashed;">
                            <!-- <v-img v-if="!process.image && form.content !== ''"
                              alt="kominfo" 
                              width="196"
                              height="196"
                              contain
                              gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                              :src="form.content"
                              class="ma-auto d-flex align-center text-center">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
    
                              <v-icon 
                                size="50" 
                                color="white">
                                mdi-cloud-upload-outline
                              </v-icon>
                            </v-img> -->
    
                            <v-icon
                              size="50" 
                              color="grey"
                              v-if="!process.image">
                              mdi-cloud-upload-outline
                            </v-icon>
    
                            <v-progress-circular v-if="process.image"
                              indeterminate
                              :color="set_color">
                            </v-progress-circular>
                          </v-card>
                        </div>
                      </uploadfolder>
                    </v-col>
                  </v-row>

                </div>

                <div v-if="form.content_type === 'file'">
                  <div class="pb-1">
                    <span class="red--text">*</span>
                    Isi Pesan
                  </div>

                  <div v-if="form.content === ''">
                    <uploaddocument 
                      v-model="upload.document">
                      <div 
                        slot="activator">
                        <v-card
                          flat
                          class="cursor-pointer"
                          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                          <v-card-text
                            class="py-2">
                            <div v-if="!process.doc"
                              class="d-flex align-center justify-center">
                              <v-icon 
                                size="28" 
                                color="#b6b6b6">
                                mdi-cloud-upload-outline
                              </v-icon>

                              <div
                                class="black--text ml-2"
                                style="opacity: 40%; font-weight: 500;">
                                Upload File
                              </div>
                            </div>

                            <div v-if="process.doc"
                              class="text-center">
                              <v-progress-circular
                                indeterminate
                                size="28"
                                color="#b6b6b6">
                              </v-progress-circular>
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>
                    </uploaddocument>
                  </div>

                  <div v-if="form.content !== ''">
                    <v-card
                      flat
                      style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                      <v-icon
                        @click="form.content = ''"
                        color="red"
                        class="cursor-pointer"
                        style="position: absolute; top: -10px; right: -10px;">
                        mdi-close-circle
                      </v-icon>

                      <v-card-text
                        class="py-3 line-text-second">
                        <div
                          class="d-flex align-center" style="width: 100%;">
                          <!-- <div style="width: 50px;">Nama</div> : {{ file_text }} -->

                          <!-- <v-row>
                            <v-col cols="12" md="2">
                              Nama
                            </v-col>
                            <v-col cols="12" md="10">
                              {{ file_text }}
                            </v-col>
                          </v-row> -->

                          <table style="width: 100%;">
                            <tr style="display: flex;">
                              <td>
                                Nama
                              </td>
                              <td class="pl-2 pr-1">
                                :
                              </td>
                              <td style="width: 100%;">
                                {{ file_text }}
                              </td>
                            </tr>
                          </table>
                        </div>

                        <!-- <div
                          class="d-flex align-center">
                          <div style="width: 50px;">Size</div> : {{ Math.round(form.file_size / 1000) }} Kb
                        </div>

                        <div
                          class="d-flex align-center">
                          <div style="width: 50px;">Mime</div> : {{ form.file_mime }}
                        </div> -->

                        <!-- <div
                          class="d-flex align-center">
                          <div style="width: 50px;">Url</div> : <a :href="form.filename" target="_blank" class="ml-1">{{ form.filename }}</a>
                        </div> -->
                      </v-card-text>
                    </v-card>
                  </div>
                </div>

              <!-- </ValidationProvider> -->
                
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-center">
              <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Kirim
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.detail"
      @keydown.esc="dialog.detail = false"
      :fullscreen="dialog.fullscreen"
      v-if="dialog.detail"
      width="700"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Detail <span v-if="selected.row.length === 1" class="pl-1">{{ selected.row[0].name }}</span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.detail = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-1">
          <div>
            <table style="width: 100%; border-spacing: 4px; border-collapse: collapse;" class="mb-4">
              <tr>
                <th style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  Tanggal
                </th>
                <th style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  Pesan Diproses
                </th>
                <th style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  Pesan Berhasil
                </th>
                <th style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  Pesan Pending
                </th>
                <th style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  Pesan Gagal
                </th>
              </tr>
              <tr>
                <td style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  {{ selected.row[0].input_datetime | datetime }}
                </td>
                <td style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  {{ pesan_diproses }}
                </td>
                <td style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  {{ pesan_berhasil }}
                </td>
                <td style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  {{ pesan_pending }}
                </td>
                <td style="border: 1px solid #eee; padding: 8px 10px; color: black;">
                  {{ pesan_gagal }}
                </td>
              </tr>
            </table>
            <!-- <div v-if="selected.row.length === 1">
              <v-row>
                <v-col cols="12" md="3" class="py-0 black--text" style="font-weight: 500;">
                  Nama
                </v-col>
                <v-col cols="12" md="9" class="py-0 black--text" style="font-weight: 500;">
                  : {{ selected.row[0].name }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" class="py-1 black--text" style="font-weight: 500;">
                  Nomor Telepon
                </v-col>
                <v-col cols="12" md="9" class="py-1 black--text" style="font-weight: 500;">
                  : {{ selected.row[0].mobilephone }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" class="py-0 black--text" style="font-weight: 500;">
                  Deskripsi
                </v-col>
                <v-col cols="12" md="9" class="py-0 black--text" style="font-weight: 500;">
                  : {{ selected.row[0].desc }}
                </v-col>
              </v-row>
            </div> -->

            <!-- <div>
              <div class="d-flex align-center">
                <div class="black--text" style="font-weight: 500;">
                  Group
                </div>
                <div class="ml-auto">
                  <div>
                    <v-btn v-if="hak_akses_menu.action.add"
                      elevation="0"
                      small
                      style="background: #4caf5033; border-radius: 10px;"
                      class="fs-12 text-capitalize font-weight-bold d-flex align-center green--text"
                      @click="dialog.form_group = true; reset_group();">
                      <v-icon size="14">mdi-plus-circle-outline</v-icon>

                      <span class="ml-1">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </div> -->

              <!-- <v-divider class="mb-3 mt-3"/> -->
            <div v-if="selected.row.length > 0">
              <div v-if="selected.row[0].content_type !== 'string'" class="mb-2">
                <div class="fs-13 black--text" style="font-weight: 300; margin-bottom: 1px;">
                  Caption Pesan
                </div>
                <div>
                  <div v-if="selected.row[0].caption !== ''" class="fs-15 black--text">
                    <div v-html="selected.row[0].caption"></div>
                  </div>
                  <div v-else>
                    <div class="fs-15 black--text" style="font-weight: 300;">
                      -
                    </div>
                  </div>
                </div>
              </div>
              <div class="fs-13 black--text" style="font-weight: 300; margin-bottom: 1px;">
                Isi Pesan yang Dikirim
              </div>
              <div class="fs-15 black--text" style="font-weight: 500;">
                <!-- {{ selected.row[0].value }} -->
                <div v-if="selected.row[0].content_type === 'string'" v-html="selected.row[0].value"></div>
                
                <div v-if="selected.row[0].content_type === 'image'">
                  <v-img 
                    class=""
                    contain
                    alt="pakualaman"
                    :width="200"
                    :height="200"
                    :src="selected.row[0].value">
                    <!-- <template v-slot:placeholder>
                      <v-row
                        class=" "
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template> -->
                  </v-img>
                </div>
                <div v-if="selected.row[0].content_type === 'file'">
                  <v-btn
                    elevation="0"
                    small
                    style="background: #4caf5033; border-radius: 10px;"
                    target="_blank"
                    width="100"
                    class="fs-12 text-capitalize font-weight-bold d-flex align-center green--text"
                    :href="selected.row[0].value"
                    >
                    <span class="ml-1">
                      Buka File
                    </span>
                  </v-btn>
                </div>
              </div>

              <div>

                <div v-if="process.detail">
                  <div class="text-center">
                    <v-progress-circular
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </div>
                </div>

                <v-card-text
                  v-if="!process.detail && group_user.length === 0"
                  class="pb-0 my-4" style="height: 400px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <v-img 
                      class="mx-auto"
                      contain
                      alt="vuetify"
                      :width="90"
                      :height="90"
                      :src="require('@/assets/image/empty.png')">
                      <!-- <template v-slot:placeholder>
                        <v-row
                          class=" "
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template> -->
                    </v-img>
                    <div class="mt-3 fs-16">
                      Belum Ada Data
                    </div>
                  </div>
                </v-card-text>

                <div class="mt-3 fs-13 black--text d-flex align-center" style="font-weight: 300; width: 100%;" v-if="!process.detail && group_user.length > 0">
                  <div>
                    Daftar Penerima
                  </div>
                  <!-- <div class="ml-3">
                    <v-btn
                      elevation="0"
                      small
                      :loading="process.detail"
                      :disabled="process.detail"
                      style="background: #4caf5033; border-radius: 6px;"
                      class="fs-12 text-capitalize font-weight-bold d-flex align-center green--text"
                      @click="toRead();">
                      <v-icon size="14">mdi-reload</v-icon>
                      <span class="ml-1">
                        Reload
                      </span>
                    </v-btn>
                  </div> -->
                </div>

                <div class="mt-2" style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;" v-if="!process.detail && group_user.length > 0">
                  <v-data-table
                    :headers="headers_user"
                    :items="group_user"
                    mobile-breakpoint="0"
                    :items-per-page="50000000"
                    hide-default-footer
                    :loading="process.detail"
                    :options.sync="options_user"
                    class="table-grid"
                  >
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="item.status !== '' ? '#1B5E20' : '#B71C1C'"
                      dark
                      class="px-5 font-weight-bold"
                    >
                      {{ item.status === '' ? '-' : item.status }}
                    </v-chip>
                    <!-- <v-progress-circular
                      v-else
                      indeterminate
                      size="18"
                      :color="set_color"
                    ></v-progress-circular> -->
                  </template>

                  </v-data-table>
                  <!-- <pagination v-if="pagination_user.total_data > 0"
                    @changePage="toRead($event)" 
                    @reloadPage="toRead($event)" 
                    :model="pagination_user" :display="paginationListUser"/> -->
                </div>
              </div>
            </div>
          </div>

          <!-- <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-center">
              <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div> -->
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.detail = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row
      class="pa-0">
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 10px;">
          <v-card-text class="pt-1 pb-2">
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">
                <div class="mr-3">
                  <v-btn v-if="hak_akses_menu.action.add"
                    elevation="0"
                    style="background: #4caf5033; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center green--text"
                    @click="dialog.form = true; reset(); type_pesan = 'Text Biasa'">
                    <v-icon size="18">mdi-plus-circle-outline</v-icon>

                    <span class="ml-1">
                      Tambah
                    </span>
                  </v-btn>
                </div>

                <div class="mr-3" v-if="selected.row.length === 1 && hak_akses_menu.action.detail">
                  <v-btn
                    @click="dialog.detail = true; toRead();"
                    elevation="0"
                    style="background: #e0e0e0; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center text-second">
                    <v-icon size="18">mdi-information-outline</v-icon>

                    <span class="ml-1">
                     Detail
                    </span>
                  </v-btn>
                </div>

                <!-- <div v-if="selected.row.length === 1 && hak_akses_menu.action.update"
                  class="mr-3" >
                  <v-btn 
                    elevation="0"
                    style="background: #2196f333; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                    @click="dialog.form = true; reset(selected.row[0]);">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Ubah
                    </span>
                  </v-btn>
                </div> -->

                <div v-if="selected.row.length > 0 && hak_akses_menu.action.delete"
                  class="mr-3" >
                  <v-btn
                    elevation="0"
                    style="background: #f4403433; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                    @click="toDelete()">
                    <v-icon size="18">mdi-delete-circle-outline</v-icon>

                    <span class="ml-1">
                      Hapus
                    </span>
                  </v-btn>
                </div>
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable

                  v-uppercase

                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>

                <!-- FREEZE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        :color="set_color"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div> -->

                <!-- HIDE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            mobile-breakpoint="0"
            class="table-grid"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '265px' : '193px'})`"
            :show-select="checkbox"
            :single-select="true"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="configHeaders"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value, item }">
              <div
                v-bind:key="header.value">
                <div v-if="header.format !== 'regex' && header.format !== 'object'">
                  {{ rowFormat(header.format, value) }} 
                </div>

                <div v-if="header.format === 'object'">
                  {{ value !== '' ? value : '-' }}
                </div>

                <div v-if="header.format === 'regex'">
                  <div v-if="item.content_type === 'string'" v-html="value" :class="item.content_type === 'string' ? 'pt-4' : ''"></div>

                  <div v-if="item.content_type === 'image'" class="py-4">
                    <v-img
                      alt="pakualaman" 
                      width="196"
                      height="196"
                      contain
                      :src="value"
                      class="d-flex align-center text-center">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <div v-if="item.content_type === 'file'">
                    <v-btn
                      elevation="0"
                      small
                      style="background: #4caf5033; border-radius: 10px;"
                      target="_blank"
                      width="100"
                      class="fs-12 text-capitalize font-weight-bold d-flex align-center green--text"
                      :href="value"
                      >
                      <span class="ml-1">
                        Buka File
                      </span>
                    </v-btn>
                  </div>
                </div>
              </div>  
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>

            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination" :display="paginationList"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,
          form: false,
          delete: false,

          attachment: false,
          map: false,
          detail: false
        },
        type: 'Text',
        search: '',
        selected: {
          row: [],
          freeze: [],
          delete: []
        },
        quill_modules: {
          toolbar: [
            ['bold', 'italic']        // toggled buttons
          ],
        },
        type_pesan: 'Text Biasa',

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        markers: [],
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 15,
            height: -10
          }
        },
        headers_user: [
          { text: 'Nama', value: 'user_name', align: 'left', sortable: false },
          { text: 'Nomor Telepon', value: 'to', align: 'left', sortable: false },
          { text: 'Status', value: 'status', align: 'left', sortable: false, style: 'color: #1B5E20;' }
        ],
        options: {},
        headers: [],
        list: [],
        category: [],
        user: [],
        contact: [],
        grup: [],
        group_user: [],
        pagination: {},
        pagination_user: {},
        paginationListUser: {},
        lastIndex: 0,
        limit: 20,
        pesan_berhasil: 0,
        pesan_gagal: 0,
        pesan_pending: 0,
        pesan_diproses: 0,

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },

        upload: {
          folder: null
        },

        autocomplete: {
          user: ''
        },
        
        upload: {
          folder: null,
          document: null
        },

        file_text: '',

        picker: false,
        form: {
          contact_type: '',
          content: '',
          contact_ids: '',
          grup_id: '',
          content_type: 'string',
          caption: ''
        },
        paginationList: {},
        process: {
          load: false,
          form: false,
          image: false,
          category: false,
          user: false,
          delete: false,
          print: false,
          detail: false,
          image: false,
          doc: false,
          reload: false
        },
        message: {
          success: '',
          error: '',
          wa: ''
        },
        statusUpdateQueue: [],
        statusUpdateTimer: null,
        batchSize: 10,
        batchDelay: 5000 // 5 detik dalam milliseconds
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      user_logs () {
        return this.$store.state.user
      },
      hak_akses_menu () {
        let menu = {}
        this.$store.state.menu.map(item => {
          if (item.id === 13) {
            menu = item
          }
        })
        return menu
      },

      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      set_filter () {
        return this.$store.state.filter
      }
    },
    watch: {
      'options': {
        handler () {
          let pages = 1

          if (this.set_filter.length > 0 && Object.keys(this.objectFine()).length > 0) {
            this.limit = parseInt(this.objectFine().limit)
            pages = this.objectFine().page
            // this.options.sortBy[0] = this.objectFine().sort
            // this.options.sortDesc[0] = this.objectFine().order_by === 'ASC' ? true : false
            this.search = this.objectFine().search
          }
          
          // let pagination = { row: this.limit, page: 1 }

          let pagination = { row: this.limit, page: pages }

          this.fetch(pagination)
        },
        deep: true
      },
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.image = this.upload.folder.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE

              // this.form.content = this.upload.folder.fileuri
              this.form.content.push(
                this.upload.folder.fileuri
              )
            }
          }
        },
        deep: true
      },
      'upload.document': {
        handler: function () {
          if (this.upload.document) {
            this.process.doc = this.upload.document.process

            if (!this.process.doc) {
              // CALLBACK FROM UPLOAD DOCUMENT

              this.form.content = this.upload.document.fileuri
              this.file_text = this.upload.document.filename
              // this.form.file_size = this.upload.document.filesize
              // this.form.file_mime = this.upload.document.filemime
            }
          }
        },
        deep: true
      }
    },
    mounted () {
      this.fetchContact()
      this.fetchGrup()
    },
    beforeDestroy () {
      // Clear timer saat component di-destroy
      if (this.statusUpdateTimer) {
        clearTimeout(this.statusUpdateTimer)
        this.statusUpdateTimer = null
      }
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value
        } else if (format === 'regex') {
          data = value
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async updateStatus (data) {
        this.message.error = ''
        // this.process.detail = true
        // this.process.reload = true
        this.message.wa = ''

        await post('admin/message/update_status', {
          data: {
            chat_id: data.chat_id,
            message_id: data.message_id
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
          
            // this.fetchToRead()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      },
      async fetchToRead (pagination = { row: 20, page: 1 }) {
        this.message.wa = ''
        // this.process.detail = true
        // this.process.reload = true
        this.paginationListUser = pagination

        let params = {
          // category_id: this.selected.category_id,
          id: this.selected.row[0].id,
          // limit: pagination.row,
          // page: pagination.page
          pagination_bool: false
        }

        const response = await get('admin/message/detail', { params })
        let res = response.data

        this.process.detail = false
          
        if (res.status === 200) {
          // this.user = res.results.data
          this.group_user = []
          res.results.data.map(item => {
            this.group_user.push({
              ...item,
              is_delivered: 'Not Connected',
            })
          })

          this.calculateMessageStats()
          // this.pagination_user = res.results.pagination
          // res.results.data.map((item, index) => {
          //   this.fetchStatus(item.chat_id, item.message_id, index)
          // })

          // this.fetchStatusTest()
        }

        // Return data untuk digunakan di tempat lain
        return res.status === 200 ? res.results.data : null
      },
      resetMessageStats () {
        this.pesan_berhasil = 0
        this.pesan_gagal = 0
        this.pesan_pending = 0
        this.pesan_diproses = 0
      },
      calculateMessageStats () {
        this.resetMessageStats()

        this.group_user.forEach(item => {
          const status = (item.status || '').toUpperCase()

          if (status === 'ERROR') {
            this.pesan_gagal += 1
          } else if (status === 'PENDING') {
            this.pesan_pending += 1
          } else if (status === 'SERVER') {
            this.pesan_diproses += 1
          } else if (['DEVICE', 'READ', 'PLAYED'].includes(status)) {
            this.pesan_berhasil += 1
          } else if (status) {
            this.pesan_pending += 1
          }
        })
      },
      async toRead (pagination = { row: 20, page: 1 }) {
        this.message.wa = ''
        this.process.detail = true
        this.process.reload = true
        this.paginationListUser = pagination

        // Clear any existing timer
        if (this.statusUpdateTimer) {
          clearTimeout(this.statusUpdateTimer)
          this.statusUpdateTimer = null
        }

        let params = {
          // category_id: this.selected.category_id,
          id: this.selected.row[0].id,
          // limit: pagination.row,
          // page: pagination.page
          pagination_bool: false
        }

        const response = await get('admin/message/detail', { params })
        let res = response.data

        // this.process.detail = false
          
        if (res.status === 200) {
          // Filter data yang statusnya bukan "DEVICE"
          this.statusUpdateQueue = res.results.data.filter(item => {
            const status = (item.status || '').toUpperCase()
            return status !== 'DEVICE'
          })

          // Mulai proses batch pertama
          if (this.statusUpdateQueue.length > 0) {
            this.processStatusBatch()
          } else {
            // Jika semua data sudah DEVICE, langsung fetchToRead
            this.fetchToRead()
          }
        }
      },
      async processStatusBatch () {
        // Ambil batch berikutnya (maksimal batchSize)
        const batch = this.statusUpdateQueue.splice(0, this.batchSize)

        if (batch.length === 0) {
          // Semua data sudah diproses, panggil fetchToRead terakhir kali
          this.fetchToRead()
          return
        }

        // Proses update status untuk batch ini
        for (let i = 0; i < batch.length; i++) {
          await this.updateStatus(batch[i])
        }

        // Setelah batch selesai, langsung fetchToRead untuk refresh data
        // dan dapatkan data terbaru untuk update queue
        const latestData = await this.fetchToRead()

        // Update queue dengan data terbaru yang belum DEVICE
        if (latestData) {
          this.statusUpdateQueue = latestData.filter(item => {
            const status = (item.status || '').toUpperCase()
            return status !== 'DEVICE'
          })
        }

        // Jika masih ada data di queue, tunggu 10 detik lalu proses batch berikutnya
        if (this.statusUpdateQueue.length > 0) {
          this.statusUpdateTimer = setTimeout(() => {
            this.processStatusBatch()
          }, this.batchDelay)
        }
      },
      toReload () {
        this.message.wa = ''
        this.resetMessageStats()
        // this.group_user.map((item, index) => {
        //   this.fetchStatus(item.chat_id, item.message_id, index)
        // })
        this.fetchStatusTest()
      },
      async fetchStatusTest (chat_id, message_id, index) {
        this.process.reload = true
        // this.process.detail = true

        let params = {
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          // search: this.search
        }

        await axios({
          url: `https://sentra7.kirimkirim.me/session/status/${this.$store.state.company.session}`,
          method: 'GET',
          params: params,
          // headers: {
          //   Authorization: process.env.VUE_APP_XAUTH,
          //   token: TokenService.getToken()
          // }
        }).then((response) => {
          let res = response

        if (res.data.message !== 'session_connected') {
            this.process.reload = false
            this.message.wa = 'Not Connected'
          } else {
            this.resetMessageStats()
            this.group_user.map((item, index) => {
          this.fetchStatus(item.chat_id, item.message_id, index)
        })
          }
          // this.fetchStatusWa()
          if (res.status === 200) {
            
          } else {
            this.message.error = res.message
          }
        })
      },
      async fetchStatus (chat_id, message_id, index) {
        this.process.reload = true

        let params = {
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          // search: this.search
          chatId: chat_id,
          messageId: message_id
        }

        await axios({
          url: `https://sentra7.kirimkirim.me/message/getInfo/${this.$store.state.company.session}`,
          method: 'POST',
          data: params,
          // headers: {
          //   Authorization: process.env.VUE_APP_XAUTH,
          //   token: TokenService.getToken()
          // }
        }).then((response) => {
          let res = response
          // this.fetchStatusWa()
          this.group_user[index].is_delivered = res.data.info.delivery.length > 0 ? 'Berhasil' : 'Gagal'
          this.group_user[index].status = res.data.info.delivery.length > 0 ? 'DEVICE' : 'ERROR'
          this.calculateMessageStats()
          this.process.reload = false
          if (res.status === 200) {
          } else {
            this.message.error = res.message
          }
        })
      },
      async fetchContact () {

        let params = {
          pagination_bool: false
        }

        await get('admin/contact/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.contact = res.results.data
          }
        })
      },
      async fetchGrup () {

        let params = {
          pagination_bool: false
        }

        await get('admin/grup/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.grup = res.results.data
          }
        })
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.paginationList = {
          page: pagination.page,
          row: pagination.row
        }

        this.limit = pagination.row

        let params = {
          path: this.$route.fullPath,

          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        TokenService.saveFilter(JSON.stringify(this.objectReplacer(this.set_filter, params)))
        this.$store.commit("setFilter", this.objectReplacer(this.set_filter, params))

        this.selected.row = []

        await get('admin/message/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Isi Pesan',
                width: '100%',
                value: 'value',
                freeze: false,
                hide: false,
                format: 'regex'
              },
              {
                text: 'caption',
                width: '200px',
                value: 'caption',
                freeze: false,
                hide: false,
                format: 'object'
              },
              {
                text: 'Waktu Buat',
                width: '200px',
                value: 'input_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              },
            ]
            
            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      objectReplacer (arrayOfObjects, newObject) {
        let index = arrayOfObjects.findIndex((obj) => obj.path === newObject.path)

        if (index === -1) {
          arrayOfObjects.push(newObject)
        } else {
          arrayOfObjects[index] = newObject
        }

        return arrayOfObjects
      },
      objectFine () {
        let self = this

        let data = this.set_filter.filter(function(v) {
          return self.$route.fullPath == v.path
        })

        return data.length > 0 ? data[0] : []
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          contact_type: 'contact',
          content: '',
          contact_ids: '',
          grup_id: '',
          content_type: 'string',
          caption: ''
        }

        this.file_text = ''

        this.picker = false

        this.process.form = false

        this.message.error = ''

        // if (this.dialog.form) this.fetchCategory()
      },
      getGeoLocation() {
        if (this.form.id === '') {
          navigator.geolocation.getCurrentPosition(position => {
            this.center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          })
        } else {
          this.center = {
            lat: this.form.latitude,
            lng: this.form.longitude
          }
        }
      },
      updatePlace(location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {

          if (this.form.content_type === 'image') {
            let form = this.form

            form.content.map((item, index) => {
              this.process.form = true

              let url = 'admin/message/add'

              // SAVE TO REST API
              post(url, {
                data: {
                  contact_type: form.contact_type,
                  content: item,
                  contact_ids: form.contact_ids,
                  grup_id: form.grup_id,
                  content_type: form.content_type,
                  caption: form.caption
                }
              })
              .then(response => {
                let res = response.data
                
                this.process.form = false

                if (res.status === 200) {
                  if (index === form.content.length - 1) {
                    this.dialog.form = false

                    this.dialog.snackbar = true
                    this.message.success = res.message

                    this.dialog.fullscreen = false

                    this.reset()

                    this.fetch()
                  }
                } else {
                  this.message.error = res.message
                }
              })
            })
            // for (let i in form.content) {
            //   this.process.form = true

            //   let url = 'admin/message/add'

            //   // SAVE TO REST API
            //   await post(url, {
            //     data: {
            //       contact_type: form.contact_type,
            //       content: form.content[0],
            //       contact_ids: form.contact_ids,
            //       grup_id: form.grup_id,
            //       content_type: form.content_type,
            //       caption: form.caption
            //     }
            //   })
            //   .then(response => {
            //     let res = response.data
                
            //     this.process.form = false

            //     if (res.status === 200) {
            //       form.content.splice(i, 1)
            //       if (form.content.length === 0) {
            //         this.dialog.form = false

            //         this.dialog.snackbar = true
            //         this.message.success = res.message

            //         this.dialog.fullscreen = false

            //         this.reset()

            //         this.fetch()
            //       }
            //     } else {
            //       this.message.error = res.message
            //     }
            //   })
            // }
          } else {
            this.process.form = true
  
            let url = 'admin/message/add'
  
            // SAVE TO REST API
            await post(url, {
              data: this.form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
                this.dialog.form = false
  
                this.dialog.snackbar = true
                this.message.success = res.message
  
                this.dialog.fullscreen = false
  
                this.reset()
  
                this.fetch()
              } else {
                this.message.error = res.message
              }
            })
          }

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      
      toDelete () {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('admin/message/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      },

      // PRINT
      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/report/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      },

      // MAP
      toMap () {
        this.markers = []

        this.dialog.map = true

        this.$gmapApiPromiseLazy().then(() => {
          let data = this.selected.row[0]

          this.markers.push({
            title: data.title,
            name: data.user_name,
            attachment: data.attachment,
            datetime: data.datetime,
            latlng: {
              lat: parseFloat(data.latitude), 
              lng: parseFloat(data.longitude)
            },
            icon: {
              url: require('@/assets/image/location_pin.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })

          this.center = this.markers.length > 0 ? this.markers[0].latlng : this.center
        })
      },
      toggleInfoWindow(marker, idx) {
        this.infoWindowPos = marker.latlng
        this.infoContent = this.getInfoWindowContent(marker)
        
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },
      getInfoWindowContent(marker) {
        let data = marker

        data.attachment = data.attachment === '' ? require('@/assets/image/image_default.png') : data.attachment

        return (`
          <div id="iw-container">
            <div class="iw-title">
              ${data.title}
            </div>

            <div class="iw-content">
              <img 
                class="image"
                height="100" 
                width="100"
                src="${data.attachment}">

              <div class="iw-subTitle" style="margin-bottom: 10px;">
                ${data.name}
              </div>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Tanggal & Waktu
              </p>

              <p style="margin-bottom: 14px; font-weight: bold;">
                ${moment(data.datetime).format('D MMM, YYYY')} Pukul ${moment(data.datetime).format('HH:mm')}
              </p>
            </div>
          </div>
        `)
      }
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
</style>